import axios from 'axios'

export const userService = {
  token,
  logout

}

function token (clientid, secret) {
  return axios.post('/auth/token', { 'clientId': clientid, 'secret': secret })
    .then(user => {
      logout()
      // login successful if there's a jwt token in the response
      if (user.data.token) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        localStorage.setItem('user', JSON.stringify(user.data))
        return JSON.parse(localStorage.getItem('user'))
      }

      return user.data
    })
}

function logout () {
  // remove user from local storage to log user out
  localStorage.removeItem('user')
}
